import script from "./goodsShare.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsShare.vue?vue&type=script&setup=true&lang=js"

import "./goodsShare.vue?vue&type=style&index=0&id=0f478f7a&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f478f7a"]])

export default __exports__